import * as React from "react";
import styled from "styled-components";
import TeaserSearch from "components/security/teaser/TeaserSearch";
import { Alert } from "components/bootstrap";
import viewJson from "./sample-dashboards/overview_view.json";
import searchJson from "./sample-dashboards/overview_search.json";
import resultJson from "./sample-dashboards/overview_results.json";
const StyledAlert = styled(Alert)`
  margin-top: 0;
`;
const hotspots = [
  {
    positionX: "50%",
    positionY: "120px",
    description: "Show performance metrics of your Data Node and managed OpenSearch cluster."
  }
];
const ClusterManagementTeaserSearch = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning" }, "Please make sure you have a valid license and Data Node configured to see the performance metrics of your Data Node and your managed OpenSearch cluster."), /* @__PURE__ */ React.createElement(
  TeaserSearch,
  {
    viewJson,
    searchJson,
    searchJobResult: resultJson,
    hotspots
  }
));
export default ClusterManagementTeaserSearch;
